import { render } from "./BxsSwitchField.vue?vue&type=template&id=76896afe&scoped=true"
import script from "./BxsSwitchField.vue?vue&type=script&lang=js"
export * from "./BxsSwitchField.vue?vue&type=script&lang=js"

import "./BxsSwitchField.vue?vue&type=style&index=0&id=76896afe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76896afe"]])

export default __exports__